import { render, staticRenderFns } from "./CreateNewSmsTemplate.vue?vue&type=template&id=6ef8176c"
import script from "./CreateNewSmsTemplate.vue?vue&type=script&lang=js"
export * from "./CreateNewSmsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports